import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const CoreContext = createContext();

export const useCore = () => {
  const context = useContext(CoreContext);
  if (!context) {
    throw new Error('useCore must be used within a CoreProvider');
  }
  return context;
};

export const CoreProvider = ({ children }) => {
  // Add your core state here
  const [theme, setTheme] = useState('dark');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [navBar, setNavBar] = useState(false);
  const [globalFilter, setGlobalFilter] = useState('');
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [token, setToken] = useState(null);
  
  const handleNavbarOpen = (open) => {
    setNavbarOpen(open);
  }
  // Add any core methods here
  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'dark' ? 'light' : 'dark');
  };

  const toggleNavBar = () => {
    setNavBar(prev => !prev);
  };
  
  const handleGlobalFilter = (value) => {
    setGlobalFilter(value);
  };

  const handleToken = (token) => {
    setToken(token);
  };

  const removeGlobalSearch = () => {
    setGlobalFilter('');
  };

  const value = {
    // State
    theme,
    loading,
    error,
    navBar,
    globalFilter,
    handleGlobalFilter,
    removeGlobalSearch,
    navbarOpen,
    handleNavbarOpen,
   
    // Methods
    setTheme,
    setLoading,
    setError,
    toggleTheme,
    toggleNavBar,
    setNavBar,
  };

  return (
    <CoreContext.Provider value={value}>
      {children}
    </CoreContext.Provider>
  );
}; 